import React, { useEffect, useState, useCallback } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { useHistory } from "react-router-dom";

import { makeStyles, withStyles } from "@material-ui/core/styles";

import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import Grid from "@material-ui/core/Grid";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import MenuItem from "@material-ui/core/MenuItem";
import XLSIcon from "../../assets/icons/excel-icon.svg";

import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardBody from "components/Card/CardBody";
import CardText from "components/Card/CardText";

import EnhancedTableHead from "../common/EnhancedTableHead";
import Loading from "../common/Loading";

import { actionCreators as actionCreatorsAdmin } from "../../_actions/adminActions";
import { PAGE_SIZE } from "../../constants";
import { yearList, currentYear } from "../../utils";

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%"
  },
  paper: {
    width: "100%",
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2)
  },
  table: {
    minWidth: 750
  },
  marginBottom: {
    marginBottom: theme.spacing(3)
  },
  cursorPointer: {
    cursor: "pointer"
  },
  filterDropdown: {
    minWidth: "120px"
  },
  expanded: {
    flex: 1
  },
  XLSIcon: {
    width: "20px",
    marginRight: "5px",
    marginTop: "-5px"
  }
}));

const headCells = [
  {
    id: "chapterName",
    numeric: false,
    disablePadding: false,
    label: "990 Reports"
  },
  {
    id: "download",
    disablePadding: false,
    label: ""
  }
];

const StyledTableRow = withStyles(theme => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover
    }
  }
}))(TableRow);

const Nine90Report = props => {
  const classes = useStyles();
  const [fiscalYear, setFiscalYear] = useState(currentYear);
  const history = useHistory();

  const { get990Report, isFetching } = props;

  const handleFiscalYear = useCallback(({ target: { value } }) => {
    setFiscalYear(value);
  }, []);

  const handleViewReport = useCallback(
    type => () => {
      get990Report(type, fiscalYear);
    },
    [history, fiscalYear]
  );

  return (
    <Container>
      <Card>
        <CardHeader color="primary" text>
          <CardText color="primary">
            <Typography variant="h4">990 Reports</Typography>
          </CardText>
        </CardHeader>
        <CardBody>
          <Grid item className={classes.marginBottom}>
            <div style={{ maxWidth: "700px", marginTop: "25px" }}>
              Only chapters that have an <b>accepted financial report</b> and
              their <b>member count</b> reported for the selected year will be
              included in each report.
            </div>
          </Grid>
          <FormControl
            variant="outlined"
            className={classes.filterDropdown}
            style={{ float: "right" }}
          >
            <InputLabel id="fiscal-year-select">Fiscal Year</InputLabel>
            <Select
              labelId="fiscal-year-select"
              value={fiscalYear}
              onChange={handleFiscalYear}
              label="Fiscal Year"
              MenuProps={{ classes: { paper: classes.menuPaper } }}
            >
              <MenuItem value={-1}>
                <em>All</em>
              </MenuItem>
              {yearList.map(value => (
                <MenuItem value={value} key={`fiy-${value}`}>
                  {value}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TableContainer>
            <Table
              className={classes.table}
              aria-labelledby="tableTitle"
              size="medium"
              aria-label="enhanced table"
            >
              <EnhancedTableHead rowCount={4} headCells={headCells} />
              <TableBody>
                {isFetching.CHAPTER_SUMMARY ? (
                  <StyledTableRow>
                    <TableCell colSpan={3} align="center">
                      <Loading />
                    </TableCell>
                  </StyledTableRow>
                ) : (
                  <>
                    <StyledTableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={1}
                      className={classes.cursorPointer}
                      onClick={handleViewReport("all")}
                    >
                      <TableCell component="th" scope="row">
                        All-Chapter Multi-Chapter Comparative Analysis
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <img src={XLSIcon} className={classes.XLSIcon} />
                        Download XLS
                      </TableCell>
                    </StyledTableRow>
                    <StyledTableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={1}
                      className={classes.cursorPointer}
                      onClick={handleViewReport("admin")}
                    >
                      <TableCell component="th" scope="row">
                        Administrators
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <img src={XLSIcon} className={classes.XLSIcon} />
                        Download XLS
                      </TableCell>
                    </StyledTableRow>
                    <StyledTableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={1}
                      className={classes.cursorPointer}
                      onClick={handleViewReport("contributions")}
                    >
                      <TableCell component="th" scope="row">
                        Contributions
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <img src={XLSIcon} className={classes.XLSIcon} />
                        Download XLS
                      </TableCell>
                    </StyledTableRow>
                    <StyledTableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={1}
                      className={classes.cursorPointer}
                      onClick={handleViewReport("scholarship")}
                    >
                      <TableCell component="th" scope="row">
                        Scholarships
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <img src={XLSIcon} className={classes.XLSIcon} />
                        Download XLS
                      </TableCell>
                    </StyledTableRow>
                    <StyledTableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={1}
                      className={classes.cursorPointer}
                      onClick={handleViewReport("advertising")}
                    >
                      <TableCell component="th" scope="row">
                        Advertising
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <img src={XLSIcon} className={classes.XLSIcon} />
                        Download XLS
                      </TableCell>
                    </StyledTableRow>
                    <StyledTableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={1}
                      className={classes.cursorPointer}
                      onClick={handleViewReport("vendor")}
                    >
                      <TableCell component="th" scope="row">
                        Vendor over $100K
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <img src={XLSIcon} className={classes.XLSIcon} />
                        Download XLS
                      </TableCell>
                    </StyledTableRow>
                    <StyledTableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={1}
                      className={classes.cursorPointer}
                      onClick={handleViewReport("special")}
                    >
                      <TableCell component="th" scope="row">
                        Special Advertising Worksheet
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <img src={XLSIcon} className={classes.XLSIcon} />
                        Download XLS
                      </TableCell>
                    </StyledTableRow>
                    <StyledTableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={1}
                      className={classes.cursorPointer}
                      onClick={handleViewReport("otherExpense")}
                    >
                      <TableCell component="th" scope="row">
                        Other Expenses
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <img src={XLSIcon} className={classes.XLSIcon} />
                        Download XLS
                      </TableCell>
                    </StyledTableRow>
                    <StyledTableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={1}
                      className={classes.cursorPointer}
                      onClick={handleViewReport("otherRevenue")}
                    >
                      <TableCell component="th" scope="row">
                        Other Revenue
                      </TableCell>
                      <TableCell component="th" scope="row">
                        <img src={XLSIcon} className={classes.XLSIcon} />
                        Download XLS
                      </TableCell>
                    </StyledTableRow>
                  </>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </CardBody>
      </Card>
    </Container>
  );
};

const mapStateToProps = state => ({
  reports: state.adminReducer.reports,
  chapterList: state.adminReducer.chapterList,
  isFetching: state.adminReducer.isFetching,
  isFetched: state.adminReducer.isFetched
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ ...actionCreatorsAdmin }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Nine90Report);
